import cn from 'classnames'
import type { HTMLAttributes, Ref } from 'react'
import styles from './clip.styles.module.css'

interface RecordingClipProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>
}

export const RecordingClip = ({ ref, ...props }: RecordingClipProps) => (
  <div {...props} ref={ref} className={cn(styles.recordingClip, props.className)} style={props.style} />
)

const RecordingWav = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.recordingWav, props.className)} style={props.style} />
)
export { RecordingWav }

const WaveContainer = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.waveContainer, props.className)} style={props.style} />
)
export { WaveContainer }
